// Theme preference: 'light' | 'dark' | 'system', stored per browser. The resolved theme is written to
// <html data-theme>; tokens.css and the Tailwind `dark:` variant read it.
export type ThemePref = 'light' | 'dark' | 'system';
const KEY = 'an-theme';

export function getThemePref(fallback: ThemePref = 'light'): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' || v === 'system' ? v : fallback;
  } catch {
    return fallback;
  }
}

const media = () => window.matchMedia('(prefers-color-scheme: dark)');
const resolve = (p: ThemePref) => (p === 'system' ? (media().matches ? 'dark' : 'light') : p);

export function applyTheme(p: ThemePref) {
  document.documentElement.dataset.theme = resolve(p);
}

export function setThemePref(p: ThemePref) {
  try {
    localStorage.setItem(KEY, p);
  } catch {
    /* storage blocked: still applies for this page */
  }
  applyTheme(p);
}

/** Call once at startup; keeps 'system' in sync with OS changes. */
export function initTheme(fallback: ThemePref = 'light') {
  applyTheme(getThemePref(fallback));
  media().addEventListener('change', () => {
    if (getThemePref(fallback) === 'system') applyTheme('system');
  });
}
